import React, { useContext, useEffect, useState } from 'react'
import './Product_Description.css'
import Increment_Decrement_Btn from '../../common/common_btn/Increment_Decrement_Btn/Increment_Decrement_Btn'
import { Button } from 'react-bootstrap'
import { faBasketShopping, faShareNodes, faSortDown, faStar, faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Product_Specification from './Product_Specification/Product_Specification'
import { Link, Navigate, useNavigate } from 'react-router-dom'
import Confirm_delivery_add_offcanvas from '../../common/offcanvas/confirm-delivery-add-offcanvas/Confirm_delivery_add_offcanvas'
import { getAllCart, postCart } from '../../../features/cart/cartSlice'

import { Context } from "../../../utils/context";
import { useDispatch, useSelector } from 'react-redux'


const Product_Description = ({ product, avgRating }) => {
  const [makeItComboModalShow, setMakeItComboModalShow] = useState(false);
  const [addDipsModalShow, setAddDipsModalShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [addCartBTNShow, setaddCartBTNShow] = useState(false);

  // console.log({ addCartBTNShow });

  const [showGoToCartModal, setshowGoToCartModal] = useState(false);
  const [show_Select_Product_By_Weight_Modal, set_show_Select_Product_By_Weight_Modal] = useState(false);
  const [disableSelect, setDisableSelect] = useState(false);

  const { signin } = useContext(Context);


  const products = [
    {
      product_name: "Add Bacon Slices",
      weight: "(+KWD 0.001)",
      image: "/assets/images/Restaurants/Products/img1.png",
    },

    {
      product_name: "Add Cheese",
      weight: "(+KWD 0.001)",
      image: "/assets/images/Restaurants/Products/img2.png",
    },

    {
      product_name: "Add Melted Cheese",
      weight: "(+KWD 0.001)",
      image: "/assets/images/Restaurants/Products/img2.png",
    },
  ];

  const [addoffcanvas, setAddoffcanvas] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const dispatch = useDispatch();

  const PostTOCart = async () => {
    try {
      const data = {
        product_id: product?.id,
        Product: product,
        quantity: quantity,
      };
      const res = await dispatch(postCart({ data: data, isSignIn: signin }));

      if (res.meta?.requestStatus === "fulfilled") {

        await dispatch(getAllCart(signin));
        setaddCartBTNShow(true)
        setshowGoToCartModal(true)
        if (res?.payload?.data?.success) {
        } else {
        }
      } else if (res.meta?.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }

  }

  const allCart = useSelector((state) => state.cart.allCarts);

  useEffect(() => { dispatch(getAllCart(signin)); }, [dispatch, product])
  const navigate = useNavigate()

  const ProductBuyNow = async () => {
    try {
      const data = {
        product_id: product?.id,
        Product: product,
        quantity: quantity,
      };
      const res = await dispatch(postCart({ data: data, isSignIn: signin }));

      if (res.meta?.requestStatus === "fulfilled") {

        await dispatch(getAllCart(signin));
        navigate("/cart")
      } else if (res.meta?.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }



  return (
    <div className="Product_Description">
      <div className="top_heading">
        <div className="heading_div">
          <p className="heading">{product?.name || ""}</p>
        </div>
        <div className="product_price_info">
          <div className="reviews_div">
            <div className="rating">
              <p>{avgRating?.average_rating || 0}</p>
            </div>
            <div className="star_div">
              <FontAwesomeIcon icon={faStar} className="star_icon" />
            </div>
          </div>
        </div>
      </div>


      <div className="description_container row">
        <div className="order-md-0 order-1">
          <div className='Product_Description_Text'>
            <p className='heading'>Description</p>
            <div className='text_holder'>
              <p>{product?.description || ""}</p>
            </div>
          </div>
        </div>


        <div className="footer_btn_holder order-md-1 order-0">
          {allCart?.data?.data?.some((item) => item?.product_id == product?.id) ? <></> :
            <div className='buynowdiv'>
              <button className='buynowbtn' type='button' onClick={ProductBuyNow}>Buy Now</button>
              {/* <button className='buynowbtn' type='button' onClick={() => setAddoffcanvas(true)}>Buy Now</button> */}
            </div>
          }

          <div className="btn_holder increeprod">


            {addCartBTNShow || allCart?.data?.data?.some((item) => item?.product_id == product?.id) ? (
              <Increment_Decrement_Btn
                setaddCartBTNShow={setaddCartBTNShow}
                product={product}
                cart={allCart?.data?.data}
                productId={product?.id}
                isSignIn={signin}
                setQuantity={setQuantity}
                quantity={quantity}
              />
            ) : (
              <Button className="custom-outline-with-bg-btn" type="button"
                onClick={PostTOCart}
              // onClick={() => {
              //   setaddCartBTNShow(true)
              //   setshowGoToCartModal(true)
              // }}
              >
                Add to Cart
              </Button>
            )}
          </div>
        </div>

        <div className="order-md-2 order-2">
          <Product_Specification product={product} />
        </div>
      </div>


      <Confirm_delivery_add_offcanvas
        show={addoffcanvas}
        onHide={() => setAddoffcanvas(false)}
      />

    </div>
  );
};

export default Product_Description;
